/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useRef, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { NewsPapers } from 'components/newspapers'
import { Link } from '@ta-interaktiv/contentbricks'
import { CSSTransition } from 'react-transition-group'
import { data } from '../data.tsx'
import { Scrollama, Step } from 'react-scrollama'

// TODO Set the correct article ID here
const ARTICLE_ID = '920966415062'
const isMobile = window.innerWidth < 800

export function AppComponent() {
  const [currentStepIndex, setCurrentStepIndex] = useState(null)
  const [scrollDirection, setScrollDirection] = useState(null)
  const [selected, setSelected] = useState(null)
  const [showInfoLayer, setShowInfoLayer] = useState(false)

  const currentData = data.find(d => d.id === currentStepIndex)
  const progressionBar = useRef(null)
  console.log(currentData)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (progressionBar && progressionBar.current) {
        progressionBar.current.style.width = `${(window.scrollY /
          document.body.scrollHeight) *
          100}%`
      }
    })
  })

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Comment la «Tribune» a traité les attentats du 11 septembre</h1>
            <h2>
              À l’occasion des vingt ans de la tragédie, la «Tribune de Genève»
              vous ouvre ses archives. Une sélection de sept textes et trois
              interviews pour vous replonger dans le tourbillon médiatique d’un
              événement sans précédent.
            </h2>
          </div>
        </div>
      </header>

      {currentStepIndex >= 1 && currentStepIndex < 99 && (
        <div className='progression'>
          <div className='bar' ref={progressionBar} />
        </div>
      )}

      <Scrollama
        onStepEnter={data => {
          console.log(data)
          setCurrentStepIndex(data.data)
          setScrollDirection(data.direction)
        }}
        onStepExit={data => {
          if (data.data === 0 && data.direction === 'up') {
            setCurrentStepIndex(-1)
          }
        }}
      >
        <Step data={0}>
        <div className='main-text'>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Léa Frischknecht, Frédéric Thomasset, Léa Sélini et Mathieu
                Rudaz
              </div>
              <div className='ta updated'>Actualisé le 10 septembre 2021</div>
            </div>
            <p className='ta text'>
              Le 11 septembre 2001, c’était il y a vingt ans. Triste
              anniversaire. Ceux qui l’ont vécu s’en rappellent forcément. Pour
              les autres, le drame appartient désormais à l’histoire du monde
              qu’on enseigne dans les écoles. Ce jour-là, 2977 personnes
              trouvent la mort dans quatre attentats suicides perpétrés sur sol
              américain. En l’espace de deux heures, trois avions de ligne
              percutent de plein fouet les tours du World Trade Center et le
              Pentagone, quand un quatrième vient s’écraser dans la campagne
              pennsylvanienne. Tout simplement irréel.
            </p>
            <p className='ta text'>
              Le 11 septembre 2001, c’était il y a vingt ans. Et comme dans
              toutes les crises majeures, le besoin d’informations est
              omniprésent. Avec 82 pages et 134 articles intégralement dédiés au
              drame durant la semaine qui a suivi, la «Tribune de Genève» s’est
              évertuée à offrir à ses lecteurs des réponses à la hauteur de
              l’événement. Des textes souvent durs, parfois émouvants et surtout
              terriblement humains. Nous vous proposons ici d’en découvrir une
              sélection. Des archives uniques - accompagnées de témoignages de
              journalistes de l’époque - pour se replonger dans la folie d’une
              entreprise terroriste sans équivalent.
            </p>
          </div>
        </div>
        <div className='ui vertical segment'>
          <div
            className='ui text center aligned container'
            style={{
              fontFamily: 'TamediaUI',
              color: '#202346',
              marginTop: '4em'
            }}
          >
            Continuez à scroller
            <div>↓</div>
          </div>
        </div>
      </div>
        </Step>
        {data.map(d => (
          <Step key={d.id} data={d.id}>
            <div className='stage' style={{ height: '100vh' }} />
          </Step>
        ))}
        <Step data={99}>
          <div className='stage' style={{ height: '80vh' }} />
        </Step>
      </Scrollama>

      {/* <CSSTransition
        unmountOnExit
        in={showInfoLayer}
        timeout={500}
        classNames='info-layer-container'
      >
        {currentData && (
          <div
            className={`info-layer ${
              currentData.color === 'yellow' ? 'colored' : ''
            }`}
            onClick={() => {
              setShowInfoLayer(false)
              setSelected(null)
              document.body.classList.remove('freeze')
            }}
          >
            <div className='info-header'>
              <div className='close-inp'>
                <i className='ui icon chevron left' />
                Retour
              </div>
            </div>
            <div className='ui vertical segment'>
              <div className='ui text container ta'>{currentData.html}</div>
            </div>
          </div>
        )}
      </CSSTransition> */}

      {/* <CSSTransition
        unmountOnExit
        in={currentStepIndex > 0 && currentStepIndex < 99}
        timeout={500}
        classNames='scroll-layer-container'
      >
        <div className='scroll-layer'>
        <div style={{fontFamily: "TamediaUI", color: "#ffffffee", fontSize: '0.35em', lineHeight: '1.5em'}}>
            Continuez à scroller
          <div>↓</div>
          </div>
        </div>
      </CSSTransition> */}

      <CSSTransition
        unmountOnExit
        in={currentData && currentData.title}
        timeout={500}
        classNames='newspapers-info-layer-container'
      >
        <div
          className='newspapers-info-layer'
          onClick={() => {
            console.log('CLICK')
            if (currentData && currentData.link) {
              window.open(`https://www.tdg.ch/${currentData.link}`)
              // setSelected(currentStepIndex)
              // document.body.classList.add('freeze')
              // setTimeout(() => {
              //   setShowInfoLayer(true)
              // }, 1000)
            }
          }}
        >
          <div className='text'>
            <div className='content'>
              {/* {currentData && currentData.link && (
                <div className='abo-title'>
                  <span className='abo-chip'>ABO</span>
                </div>
              )} */}
              <div className='title'>{currentData && currentData.title}</div>
              {currentData && currentData.description && (
                <div className='description'>{currentData.description}</div>
              )}

              {currentData && currentData.link && (
                <div className='action'>
                  <a
                    href={`https://www.tdg.ch/${currentData.link}`}
                    target='_blank'
                    rel='noreferrer'
                    className='cbLink cB'
                  >
                    <i className='icon external-link' />
                    Lire ce contenu
                  </a>
                </div>
              )}
              {
                <div
                  className='scroll-hint'
                  style={{
                    fontFamily: 'TamediaUI',
                    color: '#ffffffee',
                    fontSize: '0.35em',
                    lineHeight: '1.5em',
                    opacity: 0.5
                  }}
                >
                  Continuez à scroller
                  <div className='sarrow'>{scrollDirection === 'down' ? '↓' : '↑'}</div>
                </div>
              }
            </div>
          </div>
        </div>
      </CSSTransition>

      <NewsPapers stage={currentStepIndex} selected={selected} data={data} />

      <Footer
        title='Comment notez-vous cette contribution?'
        mailTo='frederic.thomasset@tdg.ch'
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', 'Léa Frischknecht, Frédéric Thomasset et Léa Sélini'],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}
